import { Col, Form, Row, Select, Spin, Table, Tabs } from 'antd'
import React, { Component } from 'react'
import { PmsAPI } from '../../../controller/PmsAPI';
import moment from 'moment';
import ResponsiveECharts from '../../components/ResponsiveECharts';

export class GuestPage extends Component {
    state = {
        loading: false,
        detailLoading: false,
        periodType: 'day',
        statChartOption: null,
        detailDate: null,
        details: [],
        byGenderDetails: [],
        byRegionDetails: [],
        byAgeDetails: [],
        emailHosts: [],
    }
    componentDidMount() {
        this.refresh();
    }
    refresh = () => {
        this.updateStatChart();
    }
    handleSelectPeriodType = (value) => {
        console.log("handleSelectPeriodType", value);
        this.setState({ periodType: value }, () => this.refresh());
    }
    updateStatChart = async () => {
        this.setState({ loading: true });
        const response = await PmsAPI.guest.stat(this.state.periodType).finally(() => {
            this.setState({ loading: false });
        });
        const result = response.data;
        const items = result.items;
        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // Use axis to trigger tooltip
                    type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                }
            },
            legend: {},
            dataset: {
                source: items
            },
            xAxis: {
                type: 'time',
                axisLabel: {
                    formatter: (value, index) => {
                        let today = false;
                        if (moment().format("YYYY-MM-DD") === moment(value).format("YYYY-MM-DD")) {
                            today = true;
                        }
                        let style = 'bold';
                        let result = null;
                        if (today) style = 'today';
                        if (this.state.periodType === 'day')
                            result = `{yy}\n{${style}|{MM}}\n{${style}|{dd}}\n{${style}|{ee}}`;
                        else if (this.state.periodType === 'month')
                            result = `{yyyy}\n{${style}|{MM}}`;
                        else
                            result = `{yyyy}`;
                        return result;
                    },
                    rich: {
                        bold: {
                            fontWeight: 700
                        },
                        today: {
                            color: '#aa5555',
                            fontWeight: 700
                        }
                    }
                }
            },
            yAxis: {
                type: 'value',
                name: '人數',
                min: 0,
            },
            series: [
                {
                    name: '舊客',
                    type: 'bar',
                    stack: 'total',
                    encode: { x: 'dat', y: 'old_qty' },
                },
                {
                    name: '新客',
                    type: 'bar',
                    stack: 'total',
                    encode: { x: 'dat', y: 'new_qty' },
                },
            ]
        };
        this.setState({ statChartOption: option });
    }
    handleClickChartEvent = (e) => {
        const date = e.data.dat;
        this.fetchDetail(date);
        console.log("click", e, date)
    }
    fetchDetail = async (date) => {
        this.setState({ detailLoading: true, detailDate: date });
        const p1 = PmsAPI.guest.index(this.state.periodType, date).then((response) => {
            const result = response.data;

            const emailHosts = result.items.map((row) => {
                function getEmailHost(email) {
                    if (!email) return null;
                    const atIndex = email.lastIndexOf('@');
                    if (atIndex !== -1) {
                        const domain = email.slice(atIndex + 1);
                        return domain;
                    } else {
                        return null; // 或是其他處理方式，視情況而定
                    }
                }
                return getEmailHost(row.e_mail);
            });
            this.setState({
                details: result.items,
                emailHosts: [...new Set(emailHosts)].map((emailHost) => ({ text: emailHost ?? '無', value: emailHost })),
            });
        });
        const p2 = PmsAPI.guest.statByGender(this.state.periodType, date).then((response) => {
            let result = response.data;
            const total = result.reduce((pv, cv, index) => { return pv + Number(cv.trans_tot) }, 0);
            result = result.map((item) => {
                item.proportion = item.trans_tot / total;
                return item;
            });
            this.setState({ byGenderDetails: result });
        });
        const p3 = PmsAPI.guest.statByRegion(this.state.periodType, date).then((response) => {
            let result = response.data;
            const total = result.reduce((pv, cv, index) => { return pv + Number(cv.trans_tot) }, 0);
            result = result.map((item) => {
                item.proportion = item.trans_tot / total;
                return item;
            });
            this.setState({ byRegionDetails: result });
        });
        const p4 = PmsAPI.guest.statByAge(this.state.periodType, date).then((response) => {
            let result = response.data;
            this.setState({ byAgeDetails: result });
        });
        await Promise.all([p1, p2, p3, p4]).finally(() => {
            this.setState({ detailLoading: false });
        });
    }
    render() {
        const columns = [
            {
                title: '姓名',
                dataIndex: 'alt_nam',
                key: 'alt_nam',
            },
            {
                title: '性別',
                dataIndex: 'sex_typ',
                key: 'sex_typ',
                filters: [
                    { text: '男', value: 'M' },
                    { text: '女', value: 'F' },
                ],
                onFilter: (value, record) => record.sex_typ.indexOf(value) === 0,
                render: (value) => value === 'M' ? '男' : '女',
            },
            {
                title: '生日',
                dataIndex: 'birth_dat',
                key: 'birth_dat',
                filters: [
                    { text: '10 歲以下', value: 10 },
                    { text: '10 - 19 歲', value: 20 },
                    { text: '20 - 29 歲', value: 30 },
                    { text: '30 - 39 歲', value: 40 },
                    { text: '40 - 49 歲', value: 50 },
                    { text: '50 - 59 歲', value: 60 },
                    { text: '60 - 69 歲', value: 70 },
                    { text: '70 - 79 歲', value: 80 },
                    { text: '80 - 89 歲', value: 90 },
                    { text: '90 - 99 歲', value: 100 },
                ],
                onFilter: (value, record) => {
                    const age = moment().diff(moment(record.birth_dat), 'year');
                    return age > (value - 10) && age < value;
                },
                render: (value) => moment(value).format("YYYY-MM-DD"),
                sorter: (a, b) => new Date(a.birth_dat) - new Date(b.birth_dat),
            },
            {
                title: '首次來訪',
                dataIndex: 'first_dat',
                key: 'first_dat',
                render: (value) => moment(value).format("YYYY-MM-DD"),
                sorter: (a, b) => moment(a.first_dat).diff(b.first_dat, "days")
            },
            {
                title: '最後來訪',
                dataIndex: 'last_dat',
                key: 'last_dat',
                render: (value) => moment(value).format("YYYY-MM-DD"),
                sorter: (a, b) => moment(a.first_dat).diff(b.first_dat, "days")
            },
            {
                title: '來訪次數',
                dataIndex: 'visit_nos',
                key: 'visit_nos',
                sorter: (a, b) => a.visit_nos - b.visit_nos
            },
            {
                title: '來訪天數',
                dataIndex: 'visitdat_nos',
                key: 'visitdat_nos',
                sorter: (a, b) => a.visitdat_nos - b.visitdat_nos
            },
            {
                title: '聯絡方式',
                dataIndex: 'contact1_rmk',
                key: 'contact1_rmk',
                sorter: (a, b) => a.contact1_rmk?.localeCompare(b.contact1_rmk),
            },
            {
                title: '電子郵件',
                dataIndex: 'e_mail',
                key: 'e_mail',
                filters: this.state.emailHosts,
                onFilter: (value, record) => {
                    if (value === record.email) return true;
                    if (record.e_mail && record.e_mail.indexOf('@' + value) > 0) {
                        return true;
                    }
                    return false;
                },
                sorter: (a, b) => a.e_mail?.localeCompare(b.e_mail),
            },
            {
                title: '身分證字號',
                dataIndex: 'id_nos',
                key: 'id_nos',
                sorter: (a, b) => a.id_nos?.localeCompare(b.id_nos),
            },
            {
                title: '消費金額',
                dataIndex: 'trans_tot',
                key: 'trans_tot',
                align: 'right',
                render: (value) => Number(value).toLocaleString(),
                sorter: (a, b) => a.trans_tot - b.trans_tot
            },
            {
                title: '平均每晚消費',
                dataIndex: 'trans_tot',
                key: 'trans_tot',
                align: 'right',
                render: (value, record) => Number(Math.round(value / (record.visitdat_nos <= 0 ? 1 : record.visitdat_nos))).toLocaleString(),
                sorter: (a, b) => Math.round(a.trans_tot / (a.visitdat_nos <= 0 ? 1 : a.visitdat_nos)) - Math.round(b.trans_tot / (b.visitdat_nos <= 0 ? 1 : b.visitdat_nos))
            }
        ];
        const columnsByGender = [
            {
                title: '姓別',
                dataIndex: 'gender',
                key: 'gender',
                render: (value) => {
                    switch (value) {
                        case 'F': return '女';
                        case 'M': return '男';
                        default: return '不明';
                    }
                }
            },
            {
                title: '人數',
                dataIndex: 'tot',
                key: 'tot'
            },
            {
                title: '消費總額',
                dataIndex: 'trans_tot',
                key: 'trans_tot',
                align: 'right',
                render: (value) => Number(value).toLocaleString(),
                sorter: (a, b) => a.trans_tot - b.trans_tot

            },
            {
                title: '佔比',
                dataIndex: 'proportion',
                key: 'proportion',
                align: 'right',
                render: (value) => Number(value * 100).toFixed(2),
                sorter: (a, b) => a.proportion - b.proportion
            },
            {
                title: '人均消費',
                align: 'right',
                render: (value, record) => Number((record.trans_tot / record.tot).toFixed(0)).toLocaleString()
            },
        ];
        const columnsByRegion = [
            {
                title: '地區',
                dataIndex: 'region',
                key: 'region',
                render: (value) => {
                    switch (value) {
                        case 'A': return '臺北市';
                        case 'B': return '臺中市';
                        case 'C': return '基隆市';
                        case 'D': return '臺南市';
                        case 'E': return '高雄市';
                        case 'F': return '新北市';
                        case 'G': return '宜蘭縣';
                        case 'H': return '桃園縣';
                        case 'I': return '嘉義市';
                        case 'J': return '新竹縣';
                        case 'K': return '苗栗縣';
                        case 'L': return '臺中縣';
                        case 'M': return '南投縣';
                        case 'N': return '彰化縣';
                        case 'O': return '新竹市';
                        case 'P': return '雲林縣';
                        case 'Q': return '嘉義縣';
                        case 'R': return '臺南縣';
                        case 'S': return '高雄縣';
                        case 'T': return '屏東縣';
                        case 'U': return '花蓮縣';
                        case 'V': return '臺東縣';
                        case 'W': return '金門縣';
                        case 'X': return '澎湖縣';
                        case 'Y': return '陽明山';
                        case 'Z': return '連江縣';
                        default: return '不明';
                    }
                }
            },
            {
                title: '人數',
                dataIndex: 'tot',
                key: 'tot',
                sorter: (a, b) => a.tot - b.tot,
            },
            {
                title: '消費總額',
                dataIndex: 'trans_tot',
                key: 'trans_tot',
                align: 'right',
                render: (value) => Number(value).toLocaleString(),
                sorter: (a, b) => a.trans_tot - b.trans_tot,

            },
            {
                title: '佔比',
                dataIndex: 'proportion',
                key: 'proportion',
                align: 'right',
                render: (value) => Number(value * 100).toFixed(2),
                sorter: (a, b) => a.proportion - b.proportion,
            },
            {
                title: '人均消費',
                align: 'right',
                render: (value, record) => Number((record.trans_tot / record.tot).toFixed(0)).toLocaleString(),
                sorter: (a, b) => {
                    const aAvg = a.tot ? (a.trans_tot / a.tot) : 0;
                    const bAvg = b.tot ? (b.trans_tot / b.tot) : 0;
                    return aAvg - bAvg;
                },
            },
        ];
        const columnsByAge = [
            {
                dataIndex: 'age',
                title: '年齡',
                sorter: (a, b) => a.age - b.age,
            },
            {
                dataIndex: 'count',
                title: '人數',
                defaultSortOrder: 'descend',
                sorter: (a, b) => a.count - b.count,
            },
        ];
        return (
            <Spin spinning={this.state.loading}>
                <h1>住客統計</h1>
                <Form>
                    <Row gutter={5} justify="end">
                        <Col xs={24} sm={24} lg={4}>
                            <Form.Item label="週期">
                                <Select value={this.state.periodType} onChange={this.handleSelectPeriodType}>
                                    <Select.Option key="year">年</Select.Option>
                                    <Select.Option key="month">月</Select.Option>
                                    <Select.Option key="day">日</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <ResponsiveECharts option={this.state.statChartOption} onEvents={{
                    'click': this.handleClickChartEvent
                }} />
                <Row style={{ marginBottom: 10 }}>
                    <Col span={18}>查詢日期: {this.state.detailDate ? this.state.detailDate : '無'}</Col>
                </Row>
                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane key="1" tab="明細">
                        <Table columns={columns} rowKey="gcust_cod" dataSource={this.state.details} scroll={{ x: 'max-content' }} loading={this.state.detailLoading} size="small" />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="2" tab="依地區">
                        <Table
                            size="small"
                            columns={columnsByRegion}
                            rowKey="region"
                            pagination={false}
                            dataSource={this.state.byRegionDetails}
                            scroll={{ x: 'max-content' }}
                            loading={this.state.detailLoading} />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="3" tab="依姓別">
                        <Table
                            size="small"
                            columns={columnsByGender}
                            rowKey="gender"
                            pagination={false}
                            dataSource={this.state.byGenderDetails}
                            scroll={{ x: 'max-content' }}
                            loading={this.state.detailLoading} />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="4" tab="依年齡">
                        <Table
                            size="small"
                            columns={columnsByAge}
                            rowKey="age"
                            pagination={false}
                            dataSource={this.state.byAgeDetails}
                            scroll={{ x: 'max-content' }}
                            loading={this.state.detailLoading} />
                    </Tabs.TabPane>
                </Tabs>
            </Spin>
        )
    }
}

export default GuestPage